import { Cart } from "../utils/cart";
import { addToCartApi } from "../utils/cartApi";

export const productJS = () => {
  
  // Product description
  const benefitsLink = document.getElementById("subscribe-benefits-link");
  if (benefitsLink) benefitsLink.addEventListener("click", tougleClose);

  const benefitsAction = document.querySelector("#subscribe-benefits .action");
  if (benefitsAction) benefitsAction.addEventListener("click", tougleClose);

  // Product accordion
  const ingredient = document.querySelectorAll(
    ".ingredient-panel .ingredient-panel--title"
  );
  if (ingredient) {
    ingredient.forEach((element) => {
      element.addEventListener("click", tougleAccordion(element));
    });
  }

  const faq = document.querySelectorAll(
    ".product-faq-section--panel .product-faq-section--panel-item .product-faq-section--panel-title"
  );
  if (faq) {
    faq.forEach((element) => {
      element.addEventListener("click", tougleAccordion(element));
    });
  }

  const sections = document.querySelectorAll(
    ".product-section-collapse .product--title"
  );
  if (sections) {
    sections.forEach((element) => {
      element.addEventListener("click", tougleAccordion(element));
    });
  }
};

function tougleClose() {
  const information = document.getElementById("subscribe-benefits");
  if (information) {
    if (!information.style.display) information.style.display = "none";

    information.style.display =
      information.style.display === "none" ? "block" : "none";
  }
}

function tougleAccordion(element) {
  return (e) => {
    if (!element.parentNode.classList.contains("open")) {
      element.parentNode.classList.add("open");
    } else {
      element.parentNode.classList.remove("open");
    }
  };
}
/**
 * 
 * @param {Int} variantId 
 * @param {Int} sellingPlan 
 * @param {Array} bundle
 * If a value comes in variantId it is a simple record of a product,
 * otherwise I register an array of objects with several products
 * @Return void 
 */
export async function addToCartProduct(variantId, sellingPlan = null, bundle) {
  let items;
  if(variantId){
    const variant = Number(variantId);
    items = [
      {
        id: variant,
        quantity: 1,
      },
    ];
  
    if (sellingPlan) {
      items[0].selling_plan = sellingPlan;
    }
  }
  if (bundle){
    items = bundle;
  }

  const cartClass = new Cart();

  try {
    const cart = await addToCartApi(items);
    if(bundle){
      window.location = '/checkout'
    }else{
      cartClass.updateCartSuccess(cart);  
    }
  } catch (error) {
    cartClass.openCartMessage();
  }

  
  
}
